import { Button } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IUseOrganizationRemoveUserMutationValues } from '~/lib/api/modules/Organizations/hooks/useOrganizationDeleteUserMutation';
import type { IApiGetUserResponseBody } from '~/lib/api/modules/Users';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { ErrorMessage } from '~/components/molecules/ErrorMessage';
import { useOrganizationRemoveUserMutation } from '~/lib/api/modules/Organizations/hooks/useOrganizationDeleteUserMutation';

export type IRemoveOrganizationUserFormProps = IContainerProps & {
  onSuccess?: (
    outputData: IApiGetUserResponseBody,
    inputValues: IUseOrganizationRemoveUserMutationValues,
  ) => void;
  organizationId: string;
  userId: string;
};

export const RemoveOrganizationUserForm: React.FC<
  IRemoveOrganizationUserFormProps
> = (props) => {
  const { sx, onSuccess, organizationId, userId } = props;
  const { t } = useTranslation();
  const organizationDeleteUserMutation = useOrganizationRemoveUserMutation();

  const handleRemove = (): Promise<IApiGetUserResponseBody> | undefined => {
    // eslint-disable-next-line no-alert
    const doDeletion = confirm(t('RemoveOrganizationUserForm.confirm'));

    if (doDeletion) {
      return organizationDeleteUserMutation.mutateAsync(
        { organizationId, userId },
        { onSuccess },
      );
    }
  };

  return (
    <ContentBlock sx={sx}>
      <ContentBlock.Title
        supportingText={t('RemoveOrganizationUserForm.subtitle')}
      >
        {t('RemoveOrganizationUserForm.title')}
      </ContentBlock.Title>

      <ContentBlock.Body>
        <div>
          <Button
            variant="danger"
            onClick={() => handleRemove()}
            loading={organizationDeleteUserMutation.isLoading}
          >
            {t('RemoveOrganizationUserForm.action')}
          </Button>
        </div>

        {organizationDeleteUserMutation.isError ? (
          <ErrorMessage error={organizationDeleteUserMutation.error} />
        ) : null}
      </ContentBlock.Body>
    </ContentBlock>
  );
};
